/* eslint-disable react/prop-types */
import React, { useState, useEffect} from "react";

import format from "date-fns/format";

import { ModalApp } from "components/Modal";
import DateRangePicker from "components/SearchComponents/DateRangePicker";
import DatePicker from "components/SearchComponents/DatePicker";
import Button from "components/Button";
import moment from "date-fns/format";
import {FiCalendar} from "react-icons/fi";

export default function ReserveDate({ onlyStartDate = false, rangeDates, onChange, label, labelStartDate, labelEndDate }) {

    const [open, setOpen] = useState(false);
    const [dates, setDates] = useState(rangeDates)
    const [focused, setFocused] = useState([0,0])
    const [disabled, setDisabled] = useState(false)


    useEffect(() => {
        if(onlyStartDate) {
            if(!rangeDates.startDate) {
                setDisabled(true)
            }
        } else {
            if(!rangeDates.startDate && !rangeDates.endDate) {
                setDisabled(true)
            }
        }

        setDates(rangeDates)
    },[rangeDates])

    const handleModal = () => {
        setOpen(!open);
    };

    const validateDates = (dates) => {
        let start = dates.startDate != null && moment(dates.startDate, "dd/MM/yyyy");
        let end = dates.endDate != null && moment(dates.endDate, "dd/MM/yyyy");

        return start !== end;
    }

    const handleChangeDates = (data) => {
        const date = data[0];
        const formatData = {
            startDate: date?.startDate,
            endDate: date?.endDate,
        }

        const validate = validateDates(formatData)

        if (!validate) {
            formatData.endDate = null
            setDates(formatData)
            setFocused([0,1])
            setDisabled(true)
            return false
        }

        setFocused([0,0])
        setDisabled(false)

        setDates(formatData)
        onChange(data)
    }

    const handleChangeStartDate = (data) => {
        const formatData = {
            startDate: data,
            endDate: null,
        }
        setDisabled(false)
        setDates(formatData)
        onChange([formatData])
    }

    return (
        <>
            <div className="row">
                <div className="col-6">
                    <div className="input-group">
                        <span className="input-group-custom ps-0">
                            <FiCalendar />
                        </span>
                        <input
                            className="form-control form-control-custom border-custom"
                            value={dates.startDate !== null ? format(dates?.startDate, "dd/MM/yyyy") : '' }
                            readOnly
                            onClick={handleModal}
                            placeholder={labelStartDate}
                        />
                    </div>
                </div>

                {!onlyStartDate &&

                    <div className="col-6">
                        <div className="input-group">
                        <span className="input-group-custom ps-0">
                            <FiCalendar/>
                        </span>
                            <input
                                className="form-control form-control-custom border-custom"
                                value={dates.endDate ? format(dates?.endDate, "dd/MM/yyyy") : ''}
                                readOnly
                                onClick={handleModal}
                                placeholder={labelEndDate}
                            />
                        </div>
                    </div>
                }
            </div>

            <ModalApp show={open} handleModal={handleModal}>
                <p className="label-modal">{label}</p>

                <div className="row shadow-sm mb-1 mt-4">
                    <div className="col-6">
                        <div className={`d-flex flex-column gap-1 py-2 ${focused[1] === 0 && 'border-focused'}`}>
                            <span className="text-sm fw-bold" style={{color: "#263238"}}>{labelStartDate}</span>
                            <span className="text-sm">
                                { dates?.startDate
                                    ? format(dates?.startDate, "dd/MM/yyyy") : '-'}
                            </span>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className={`d-flex flex-column gap-1 py-2 ${focused[1] === 1 && 'border-focused'}`}>
                            <span className="text-sm fw-bold" style={{color: "#263238"}}>{labelEndDate}</span>
                            <span className="text-sm">{dates?.endDate
                                ? format(dates?.endDate, "dd/MM/yyyy") : '-' }</span>
                        </div>
                    </div>
                </div>

                { onlyStartDate
                    ? <DatePicker
                        onChange={handleChangeStartDate}
                        dates={dates}
                    />
                    : <DateRangePicker
                        onChange={handleChangeDates}
                        dates={dates}
                      />
                }

                <div className="my-4 d-flex justify-content-center">
                    <Button
                        type="button"
                        width="200px"
                        onClick={handleModal}
                        disabled={disabled}
                    >Confirmar</Button>
                </div>
            </ModalApp>
        </>
    )
}
